import { getMemberTicketRedemptionCards } from './get-member-ticket-redemption-cards';
export const getMemberTicketRedemptionCardById = (id) => {
    var _a;
    return (_a = getMemberTicketRedemptionCards()) === null || _a === void 0 ? void 0 : _a.find(card => card.id === id);
};
